import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  try { return format(parseISO(iso), 'yyyy-MM-dd'); } catch { return iso ?? '—'; }
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try { return format(parseISO(iso), 'yyyy-MM-dd HH:mm'); } catch { return iso ?? '—'; }
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try { return formatDistanceToNowStrict(parseISO(iso), { addSuffix: true }); } catch { return ''; }
}

export function daysBetween(startIso: string | null, endIso: string | null = null): number | null {
  if (!startIso) return null;
  const start = parseISO(startIso);
  const end = endIso ? parseISO(endIso) : new Date();
  return Math.max(0, Math.floor((end.getTime() - start.getTime()) / 86400000));
}

export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase() ?? '').join('');
}

export function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n - 1) + '…' : s;
}
